



















import { Component , Vue } from 'vue-property-decorator';
import TopNavigationBar from '../components/TopNavigationBar.vue';
import LeftNavigationBar from '../components/LeftNavigationBar.vue';
import '../assets/css/MainLayout.scss';
import { MedTransGoConstants } from '../util/constants';
@Component({
    components: {
        TopNavigationBar,
        LeftNavigationBar,
    },
})
export default class MainLayout extends Vue {

    public mounted() {
        if (this.$route.path === '/') {
            this.$router.push({ name : MedTransGoConstants.VIEW_REQUESTS_PANEL_NAME });
        }
    }

}
